import { IconButton, type IconButtonProps, Tooltip } from '@mui/material';
import type { FC, ReactNode } from 'react';

type Props = {
  isActive?: boolean;
  onClick: VoidFunction;
  label: string;
  icon: ReactNode;
  isDisabled?: boolean;
  size?: IconButtonProps['size'];
};

export const ToolbarButton: FC<Props> = ({
  isActive,
  onClick,
  label,
  icon,
  isDisabled,
  size = 'small',
}) => (
  <Tooltip title={label}>
    <span>
      <IconButton
        size={size}
        onClick={onClick}
        disabled={isDisabled}
        aria-label={label}
        aria-pressed={isActive}
        color={isActive ? 'primary' : 'default'}
        sx={{
          borderRadius: 1,
          backgroundColor: isActive ? 'action.selected' : 'transparent',
        }}
      >
        {icon}
      </IconButton>
    </span>
  </Tooltip>
);
